<template>
    <MainHeader app="clp" @centerSelected="loadLeadsByCenter()" />
    <main class="main">
        <FirstLoginModal
            v-if="!authStore.user.settings.hide_information"
        ></FirstLoginModal>

        <div
            class="modal-holder"
            v-if="authStore.showPersonSearch"
            @click="authStore.showPersonSearch = false"
        >
            <form
                @submit.prevent="findLeads()"
                class="modal-card modal-card-search-box"
                @click.stop=""
            >
                <div class="modal-card-header">
                    <h3>{{ $t("clp.SearchMember") }}</h3>
                </div>

                <div class="modal-content scroll-bar">
                    <div class="input-holder">
                        <label> {{ $t("clp.Name") }}</label>
                        <input type="text" v-model="search.name" />
                    </div>

                    <div class="input-holder">
                        <label> {{ $t("clp.MemberNumber") }}</label>
                        <input type="text" v-model="search.personKey" />
                    </div>

                    <div class="input-holder">
                        <label> {{ $t("clp.Phonenumber") }}</label>
                        <input type="text" v-model="search.phone" />
                    </div>

                    <div class="search-results scroll-bar">
                        <div v-if="findLeadIsLoading">
                            <div class="lds-ellipsis lds-ellipsis-blue">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>

                        <div
                            v-for="person in searchResults"
                            @click="
                                showFindedPersonCard(person.personId.externalId)
                            "
                        >
                            <h4>
                                {{ person.firstName }} {{ person.lastName }}
                            </h4>
                            <div>
                                {{ person.personId.center }}p{{
                                    person.personId.id
                                }}
                            </div>
                        </div>

                        <div v-if="searchResultEmpty">
                            {{ $t("clp.PersonsNotFound") }}
                        </div>
                    </div>
                </div>

                <div class="modal-buttons">
                    <div class="buttons button-holder-right">
                        <button
                            type="button"
                            @click="authStore.showPersonSearch = false"
                            class="button button-transparent"
                        >
                            {{ $t("clp.Close") }}
                        </button>

                        <button
                            type="submit"
                            :class="findLeadIsLoading ? 'button-disabled' : ''"
                            :disabled="findLeadIsLoading"
                            class="button"
                        >
                            {{ $t("clp.Search") }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
        <!-- Statistik -->

        <div
            class="statistics"
            v-if="
                currentStats[authStore.user.current_center.center_id]?.done ===
                undefined
            "
        ></div>

        <div
            class="statistics"
            v-if="
                currentStats[authStore.user.current_center.center_id]?.done !==
                undefined
            "
        >
            <div>{{ $t("clp.TodaysStatistic") }}</div>
            <ul>
                <li>
                    {{ $t("clp.DoneVSPlace") }}
                    <span
                        :class="
                            currentStats[
                                authStore.user.current_center.center_id
                            ]?.done <
                            currentStats[
                                authStore.user.current_center.center_id
                            ]?.number_of_todos
                                ? 'color-red'
                                : 'color-black'
                        "
                        class="bold"
                        >{{
                            currentStats[
                                authStore.user.current_center.center_id
                            ]?.done
                        }}</span
                    ><span class="color-black bold"
                        >/{{
                            currentStats[
                                authStore.user.current_center.center_id
                            ]?.number_of_todos
                        }}</span
                    >
                    <span
                        v-if="
                            currentStats[
                                authStore.user.current_center.center_id
                            ]?.number_of_todos !=
                            currentStats[
                                authStore.user.current_center.center_id
                            ]?.number_of_todos_orginal
                        "
                        class="bold color-black"
                        >&nbsp;({{
                            currentStats[
                                authStore.user.current_center.center_id
                            ]?.number_of_todos_orginal
                        }})</span
                    >
                </li>
                <li>
                    {{ $t("clp.CallsLeftToday") }}
                    <span class="bold color-black">{{
                        currentStats[authStore.user.current_center.center_id]
                            ?.number_of_todos -
                        currentStats[authStore.user.current_center.center_id]
                            ?.done
                    }}</span>
                </li>

                <li>
                    {{ $t("clp.ResponseRate") }}
                    <span class="bold color-black"
                        >{{
                            currentStats[
                                authStore.user.current_center.center_id
                            ]?.stats.all?.response_rate
                        }}%</span
                    >
                </li>

                <li>
                    {{ $t("clp.ConversionRate") }}
                    <span class="bold color-black"
                        >{{
                            currentStats[
                                authStore.user.current_center.center_id
                            ]?.stats.all?.conversion_rate
                        }}%</span
                    >
                </li>

                <li>
                    {{ $t("clp.ProgressionRate") }}
                    <span class="bold color-black"
                        >{{
                            currentStats[
                                authStore.user.current_center.center_id
                            ]?.stats.all?.progression_rate
                        }}%</span
                    >
                </li>
            </ul>
            <div class="number-of-leads">
                <span
                    :class="
                        numberOfTodosToShow ==
                        authStore.user.current_center.number_of_todos
                            ? 'active'
                            : ''
                    "
                    @click="
                        numberOfTodosToShow =
                            authStore.user.current_center.number_of_todos
                    "
                    >{{ $t("clp.Today") }} ({{
                        currentStats[authStore.user.current_center.center_id]
                            ?.number_of_todos
                    }})</span
                ><span class="number-of-leads-center"> / </span>
                <span
                    :class="
                        numberOfTodosToShow == sortOrder.length ? 'active' : ''
                    "
                    @click="numberOfTodosToShow = sortOrder.length"
                    >{{ $t("clp.All") }} ( {{ sortOrder.length }})</span
                >
            </div>
        </div>

        <div v-if="loading" class="loading">
            <div class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>

        <div class="board-tabs-holder">
            <ul class="board-tabs">
                <li
                    v-for="(boardItem, index) in board"
                    :class="currentBoardIndex === index ? 'current' : ''"
                    @click="changeBoard(index)"
                >
                    {{ boardItem.name }}
                </li>
            </ul>
        </div>

        <div class="board" v-if="showBoard">
            <div
                v-for="(boardItem, categoryKey) in board[currentBoardIndex]
                    ?.categories"
                class="board-column"
            >
                <div class="board-title">
                    <h2>{{ boardItem.name }}</h2>
                    <div
                        class="board-info-button"
                        v-if="boardItem.info !== null"
                    >
                        <i
                            class="material-icons-outlined icon-rock pointer"
                            @click="showInfoInModal(boardItem, $event)"
                            >info</i
                        >
                    </div>
                </div>
                <transition-group name="list" tag="ul">
                    <li
                        v-for="(lead, leadKey) in sortLeads(boardItem.items)"
                        :key="lead.name"
                        class="board-item-holder"
                    >
                        <div
                            v-if="lead.being_edited !== null"
                            class="board-item-locked"
                        >
                            {{ lead.being_edited_by }}
                        </div>
                        <div
                            class="board-item"
                            :class="{
                                processed:
                                    lead.last_outcome !== null &&
                                    !lead.handle_later,
                                handleLater: lead.handle_later,
                                'being-edited': lead.being_edited !== null,
                            }"
                            @click="
                                showCard(
                                    lead.being_edited_by_id,
                                    lead.CLP_Session_id,
                                    currentBoardIndex,
                                    categoryKey,
                                    leadKey,
                                    boardItem.newActions,
                                    false,
                                    true,
                                    true
                                )
                            "
                        >
                            <div class="board-item-title">{{ lead.name }}</div>
                            <div class="board-item-type">
                                {{ $t("clp.Type") }}:
                                {{ translateType(lead.type) }}
                            </div>
                            <div class="board-item-status">
                                {{ $t("clp.Outcome") }}:&nbsp;
                                {{
                                    getTranslation(
                                        "actions",
                                        lead.last_outcome_action?.uuid
                                    )
                                }}
                            </div>
                            <div class="board-item-icons">
                                <i
                                    :class="
                                        lead?.can_send_sms
                                            ? 'color-sand'
                                            : 'color-green'
                                    "
                                    class="material-icons-outlined"
                                    >send_to_mobile</i
                                >

                                <span>{{ formatDate(lead?.sms_sended) }}</span>
                            </div>
                        </div>
                    </li>
                </transition-group>
            </div>
        </div>

        <div
            class="modal-holder"
            tabindex="0"
            v-show="currentPerson.data !== undefined"
            @keydown.esc="currentPerson = {}"
            @click="currentPerson = {}"
        >
            <div
                class="person-card"
                @click.stop=""
                :class="[
                    showPersonCard && showPersonCard !== false ? 'show' : '',
                    showSuccess ? 'show-success' : '',
                ]"
            >
                <div class="person-card-header">
                    <div
                        class="person-card-image"
                        :class="
                            currentPerson?.data?.clp_data?.contactedToday !==
                            false
                                ? 'success'
                                : ''
                        "
                    ></div>

                    <div class="person-card-headline">
                        <h1>
                            {{ currentPerson?.data?.person?.person?.firstName }}
                            {{ currentPerson?.data?.person?.person?.lastName }}
                        </h1>
                        <h2>
                            {{ $t("clp.Leads") }}:
                            {{
                                getTranslation(
                                    "categories",
                                    currentPerson?.data?.clp_data
                                        ?.currentCategory
                                )
                            }}
                        </h2>
                    </div>
                    <div class="modal-card-header-right">
                        <div
                            class="board-info-button"
                            v-if="
                                this.personCardInfoTexts.sellMembership !== ''
                            "
                        >
                            <i
                                class="material-icons-outlined icon-rock pointer icon-info"
                                @mouseover="
                                    showInfo(
                                        {
                                            name: $t('clp.SellMembership'),
                                            info: this.personCardInfoTexts
                                                .sellMembership,
                                        },
                                        $event
                                    )
                                "
                                @mouseout="showInfo(false, $event)"
                                >info</i
                            >
                        </div>
                        <div class="button-text sell-membership color-rock">
                            <a
                        :href="buildSalesUrl()"
                        class="button-text sell-membership"
                    >
                        {{ $t("clp.SellMembership") }}
                    </a>
                        </div>
                        <i class="material-icons-outlined color-blue pointer"
                            >open_in_new</i
                        >
                    </div>
                </div>

                <div class="modal-content scroll-bar">
                    <div class="person-card-content">
                        <div class="person-card-content-left">
                            <div class="list">
                                <div class="list-content">
                                    <div class="list-row">
                                        <div>{{ $t("clp.Type") }}</div>
                                        <div>
                                            <div class="board-info-button">
                                                <i
                                                    class="material-icons-outlined icon-rock pointer"
                                                    @mouseover="
                                                        showInfo(
                                                            getTypeInfoText(
                                                                currentPerson
                                                                    ?.data
                                                                    ?.clp_data
                                                                    ?.type
                                                            ),
                                                            $event
                                                        )
                                                    "
                                                    @mouseout="
                                                        showInfo(false, $event)
                                                    "
                                                    >info</i
                                                >
                                            </div>
                                            <span class="h4 ml-4 mb-0">{{
                                                getTranslation(
                                                    "types",
                                                    currentPerson?.data
                                                        ?.clp_data?.type
                                                )
                                            }}</span>
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>{{ $t("clp.Date") }}</div>
                                        <div>
                                            {{
                                                currentPerson?.data?.clp_data
                                                    ?.typeDate
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="person-card-content-right">
                            <div class="list">
                                <div class="list-content">
                                    <div class="list-row">
                                        <div>
                                            {{ $t("clp.ContactStatus") }}
                                        </div>
                                        <div
                                            class="bold color-green"
                                            v-if="
                                                currentPerson?.data?.clp_data
                                                    ?.contactedToday !==
                                                    undefined &&
                                                currentPerson?.data?.clp_data
                                                    ?.contactedToday !== false
                                            "
                                        >
                                            {{ $t("clp.ContactedToday") }}
                                        </div>
                                        <div
                                            class="bold color-red"
                                            v-if="
                                                currentPerson?.data?.clp_data
                                                    ?.contactedToday === false
                                            "
                                        >
                                            {{ $t("clp.NotContactedToday") }}
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>{{ $t("clp.SMSSended") }}</div>
                                        <div class="color-green">
                                            {{
                                                currentPerson?.data?.clp_data
                                                    ?.sms_sended
                                            }}
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>
                                            {{ $t("clp.LastContactOnType") }}
                                        </div>
                                        <div>
                                            {{
                                                currentPerson?.data?.clp_data
                                                    ?.numberOfContactsOnCurrentCategory
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="person-card-content">
                        <div class="person-card-content-left">
                            <div class="list">
                                <div class="list-header">
                                    <h3>{{ $t("clp.Persondata") }}</h3>
                                    <div
                                        class="board-info-button"
                                        v-if="
                                            this.personCardInfoTexts
                                                .personData !== ''
                                        "
                                    >
                                        <i
                                            class="material-icons-outlined icon-rock pointer"
                                            @mouseover="
                                                showInfo(
                                                    {
                                                        name: $t(
                                                            'clp.Persondata'
                                                        ),
                                                        info: this
                                                            .personCardInfoTexts
                                                            .personData,
                                                    },
                                                    $event
                                                )
                                            "
                                            @mouseout="showInfo(false, $event)"
                                            >info</i
                                        >
                                    </div>
                                </div>
                                <div class="list-content">
                                    <div class="list-row">
                                        <div>{{ $t("clp.PersonKey") }}</div>
                                        <div
                                            v-if="
                                                currentPerson?.data?.person
                                                    ?.person?.personId?.center
                                            "
                                        >
                                            {{
                                                currentPerson?.data?.person
                                                    ?.person?.personId?.center
                                            }}p{{
                                                currentPerson?.data?.person
                                                    ?.person?.personId?.id
                                            }}
                                        </div>
                                        <div v-else>-</div>
                                    </div>
                                    <div class="list-row">
                                        <div>{{ $t("clp.Firstname") }}</div>
                                        <div>
                                            {{
                                                currentPerson?.data?.person
                                                    ?.person?.firstName
                                            }}
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>{{ $t("clp.Lastname") }}</div>
                                        <div>
                                            {{
                                                currentPerson?.data?.person
                                                    ?.person?.lastName
                                            }}
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>
                                            {{ $t("clp.PhonenumberWork") }}
                                        </div>
                                        <div>
                                            {{
                                                currentPerson?.data?.person
                                                    ?.personCommunication
                                                    ?.workPhoneNumber
                                            }}
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>
                                            {{ $t("clp.PhonenumberHome") }}
                                        </div>
                                        <div>
                                            {{
                                                currentPerson?.data?.person
                                                    ?.personCommunication
                                                    ?.homePhoneNumber
                                            }}
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>{{ $t("clp.Mobilenumber") }}</div>
                                        <div>
                                            {{
                                                currentPerson?.data?.person
                                                    ?.personCommunication
                                                    ?.mobilePhoneNumber
                                            }}
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>{{ $t("clp.Persontype") }}</div>
                                        <div>
                                            {{
                                                currentPerson?.data?.person
                                                    ?.personTypeAndStatus
                                                    ?.personType
                                            }}
                                        </div>
                                    </div>

                                    <div
                                        class="list-row"
                                        v-if="
                                            currentPerson?.data?.person
                                                ?.personTypeAndStatus
                                                ?.personType === 'CORPORATE'
                                        "
                                    >
                                        <div>
                                            {{ $t("clp.CompanyAgreement") }}
                                        </div>
                                        <div
                                            v-if="
                                                currentPerson?.data?.person
                                                    ?.companyRelation?.agreement
                                                    ?.name
                                            "
                                        >
                                            {{
                                                currentPerson?.data?.person
                                                    ?.companyRelation?.agreement
                                                    ?.name
                                            }}
                                        </div>

                                        <div
                                            v-if="
                                                !currentPerson?.data?.person
                                                    ?.companyRelation?.agreement
                                                    ?.name
                                            "
                                        >
                                            Saknas
                                        </div>
                                    </div>

                                    <div class="list-row">
                                        <div>{{ $t("clp.Age") }}</div>
                                        <div>
                                            {{
                                                currentPerson?.data?.person
                                                    ?.person?.age
                                            }}
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>{{ $t("clp.City") }}</div>
                                        <div>
                                            {{
                                                currentPerson?.data?.person
                                                    ?.person?.address?.country
                                            }}
                                            -
                                            {{
                                                currentPerson?.data?.person
                                                    ?.person?.address?.zipName
                                            }}
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>
                                            {{ $t("clp.DownloadedApp") }}
                                        </div>
                                        <div>
                                            {{
                                                currentPerson?.data?.person
                                                    ?.extendedAttributes
                                                    ?.TWIIKUSER == "true"
                                                    ? $t("clp.Yes")
                                                    : $t("clp.No")
                                            }}
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>{{ $t("clp.QRCode") }}</div>
                                        <div
                                            v-if="
                                                currentPerson?.usedQRCode ===
                                                true
                                            "
                                        >
                                            {{ $t("clp.Yes") }}
                                        </div>
                                        <div
                                            v-if="
                                                currentPerson?.usedQRCode ===
                                                false
                                            "
                                        >
                                            {{ $t("clp.No") }}
                                        </div>
                                        <div v-else>
                                            <div class="loading-spinner"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="list">
                                <div class="list-header">
                                    <h3>{{ $t("clp.VisitHistory") }}</h3>
                                    <div
                                        class="board-info-button"
                                        v-if="
                                            this.personCardInfoTexts
                                                .visitHistory !== ''
                                        "
                                    >
                                        <i
                                            class="material-icons-outlined icon-rock pointer"
                                            @mouseover="
                                                showInfo(
                                                    {
                                                        name: $t(
                                                            'clp.VisitHistory'
                                                        ),
                                                        info: this
                                                            .personCardInfoTexts
                                                            .visitHistory,
                                                    },
                                                    $event
                                                )
                                            "
                                            @mouseout="showInfo(false, $event)"
                                            >info</i
                                        >
                                    </div>
                                </div>
                                <div class="list-content">
                                    <div class="list">
                                        <div class="list-subheadline">
                                            {{ $t("clp.LastVisit") }}
                                        </div>
                                        <div class="list-row">
                                            <div>
                                                {{ $t("clp.LastCheckin") }}
                                            </div>
                                            <div v-if="!personExistInExerp">
                                                -
                                            </div>
                                            <div
                                                v-else-if="
                                                    currentPerson.lastCheckin
                                                "
                                            >
                                                {{
                                                    currentPerson.lastCheckin
                                                        ?.date !== undefined &&
                                                    currentPerson.lastCheckin
                                                        ?.date !== ""
                                                        ? currentPerson
                                                              .lastCheckin
                                                              .date +
                                                          " (" +
                                                          currentPerson
                                                              .lastCheckin
                                                              .days_since_last_checkin +
                                                          " " +
                                                          $t("clp.days") +
                                                          ")"
                                                        : "-"
                                                }}
                                            </div>
                                            <div v-else>
                                                <div
                                                    class="loading-spinner"
                                                ></div>
                                            </div>
                                        </div>
                                        <div class="list-row">
                                            <div>{{ $t("clp.Center") }}</div>
                                            <div v-if="!personExistInExerp">
                                                -
                                            </div>
                                            <div
                                                v-else-if="
                                                    currentPerson.lastCheckin
                                                "
                                            >
                                                {{
                                                    currentPerson.lastCheckin
                                                        ?.center_name !==
                                                    undefined
                                                        ? currentPerson
                                                              .lastCheckin
                                                              .center_name
                                                        : "-"
                                                }}
                                            </div>
                                            <div v-else>
                                                <div
                                                    class="loading-spinner"
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="list">
                                        <div class="list-subheadline">
                                            {{ $t("clp.LastGTPass") }}
                                        </div>
                                        <div class="list-row">
                                            <div>{{ $t("clp.Date") }}</div>
                                            <div v-if="!personExistInExerp">
                                                -
                                            </div>
                                            <div
                                                v-else-if="
                                                    currentPerson.lastParticipations
                                                "
                                            >
                                                {{
                                                    currentPerson
                                                        .lastParticipations
                                                        ?.class?.date !==
                                                    undefined
                                                        ? currentPerson
                                                              .lastParticipations
                                                              .class.date
                                                        : "-"
                                                }}
                                            </div>
                                            <div v-else>
                                                <div
                                                    class="loading-spinner"
                                                ></div>
                                            </div>
                                        </div>
                                        <div class="list-row">
                                            <div>{{ $t("clp.Pass") }}:</div>
                                            <div v-if="!personExistInExerp">
                                                -
                                            </div>
                                            <div
                                                v-else-if="
                                                    currentPerson.lastParticipations
                                                "
                                            >
                                                {{
                                                    currentPerson
                                                        .lastParticipations
                                                        ?.class?.activity !==
                                                    undefined
                                                        ? currentPerson
                                                              .lastParticipations
                                                              .class.activity
                                                        : "-"
                                                }}
                                            </div>
                                            <div v-else>
                                                <div
                                                    class="loading-spinner"
                                                ></div>
                                            </div>
                                        </div>
                                        <div class="list-row">
                                            <div>{{ $t("clp.Center") }}:</div>
                                            <div v-if="!personExistInExerp">
                                                -
                                            </div>
                                            <div
                                                v-else-if="
                                                    currentPerson.lastParticipations
                                                "
                                            >
                                                {{
                                                    currentPerson
                                                        .lastParticipations
                                                        ?.class?.center_name !==
                                                    undefined
                                                        ? currentPerson
                                                              .lastParticipations
                                                              .class.center_name
                                                        : "-"
                                                }}
                                            </div>
                                            <div v-else>
                                                <div
                                                    class="loading-spinner"
                                                ></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="list-subheadline">
                                        {{ $t("clp.LastPTPass") }}
                                    </div>
                                    <div class="list-row">
                                        <div>{{ $t("clp.Date") }}</div>
                                        <div v-if="!personExistInExerp">-</div>
                                        <div
                                            v-else-if="
                                                currentPerson.lastParticipations
                                            "
                                        >
                                            {{
                                                currentPerson.lastParticipations
                                                    ?.pt?.date !== undefined
                                                    ? currentPerson
                                                          .lastParticipations.pt
                                                          .date
                                                    : "-"
                                            }}
                                        </div>
                                        <div v-else>
                                            <div class="loading-spinner"></div>
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>{{ $t("clp.Pass") }}:</div>
                                        <div v-if="!personExistInExerp">-</div>
                                        <div
                                            v-else-if="
                                                currentPerson.lastParticipations
                                            "
                                        >
                                            {{
                                                currentPerson.lastParticipations
                                                    ?.pt?.activity !== undefined
                                                    ? currentPerson
                                                          .lastParticipations.pt
                                                          .activity
                                                    : "-"
                                            }}
                                        </div>
                                        <div v-else>
                                            <div class="loading-spinner"></div>
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>{{ $t("clp.Center") }}:</div>
                                        <div v-if="!personExistInExerp">-</div>
                                        <div
                                            v-else-if="
                                                currentPerson.lastParticipations
                                            "
                                        >
                                            {{
                                                currentPerson.lastParticipations
                                                    ?.pt?.center_name !==
                                                undefined
                                                    ? currentPerson
                                                          .lastParticipations.pt
                                                          .center_name
                                                    : "-"
                                            }}
                                        </div>
                                        <div v-else>
                                            <div class="loading-spinner"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="list">
                                <div class="list-header">
                                    <h3>{{ $t("clp.JournalAndNotes") }}</h3>
                                    <div
                                        class="button-text"
                                        @click="showJournalNotes = true"
                                    >
                                        {{ $t("clp.ShowMore") }}
                                    </div>
                                </div>
                                <div class="journal-holder">
                                    <div
                                        class="journal-note-item"
                                        v-for="(
                                            journalNote, index
                                        ) in currentPerson?.journalNotes"
                                        v-show="index === 0"
                                    >
                                        <div
                                            class="journal-date"
                                            v-show="index === 0"
                                        >
                                            {{ journalNote.creationDate }} -
                                            {{ journalNote.creationTime }}
                                        </div>
                                        <div
                                            class="journal-note"
                                            v-show="index === 0"
                                        >
                                            {{
                                                formatJournalDate(
                                                    journalNote?.text
                                                )
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="person-card-content-right">
                            <!-- Kontaktlogg -->
                            <div class="list">
                                <div class="list-header">
                                    <h3>{{ $t("clp.ContactLog") }}</h3>
                                    <div
                                        class="button-text"
                                        @click="showLogs = true"
                                    >
                                        {{ $t("clp.ShowMore") }}
                                    </div>
                                </div>
                                <div class="list-content">
                                    <div class="list-row">
                                        <div>{{ $t("clp.Date") }}</div>
                                        <div>
                                            {{
                                                currentPerson?.data?.logs[0]
                                                    ?.date
                                            }}
                                            {{
                                                getDatePrefix(
                                                    currentPerson?.data?.logs[0]
                                                        ?.daysSinceLog
                                                )
                                            }}
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>{{ $t("clp.Time") }}</div>
                                        <div>
                                            {{
                                                currentPerson?.data?.logs[0]
                                                    ?.time
                                            }}
                                        </div>
                                    </div>
                                    <div
                                        class="list-row"
                                        v-if="
                                            currentPerson?.data?.logs[0]
                                                ?.outcome !== ''
                                        "
                                    >
                                        <div>{{ $t("clp.Outcome") }}</div>
                                        <div class="bold">
                                            {{
                                                getTranslation(
                                                    "actions_categories",
                                                    currentPerson?.data?.logs[0]
                                                        ?.outcome_id
                                                )
                                            }}
                                            <span
                                                v-if="
                                                    currentPerson?.data?.logs[0]
                                                        ?.outcome
                                                "
                                                ><i
                                                    class="outcome-arrow material-icons arrow"
                                                    >east</i
                                                >
                                            </span>
                                            {{
                                                getTranslation(
                                                    "actions",
                                                    currentPerson?.data?.logs[0]
                                                        ?.action_id
                                                )
                                            }}
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>{{ $t("clp.Comment") }}</div>
                                        <div>
                                            {{
                                                currentPerson?.data?.logs[0]
                                                    ?.comment
                                            }}
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>{{ $t("clp.Type") }}</div>
                                        <div>
                                            {{
                                                getTranslation(
                                                    "types",
                                                    currentPerson?.data?.logs[0]
                                                        ?.type
                                                )
                                            }}
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>{{ $t("clp.User") }}</div>
                                        <div>
                                            {{
                                                currentPerson?.data?.logs[0]
                                                    ?.handled_by
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Senaste köp -->
                            <div class="list">
                                <div class="list-header">
                                    <h3>{{ $t("clp.LastPurchase") }}</h3>
                                    <div
                                        class="board-info-button"
                                        v-if="
                                            this.personCardInfoTexts
                                                .lastPurchase !== ''
                                        "
                                    >
                                        <i
                                            class="material-icons-outlined icon-rock pointer"
                                            @mouseover="
                                                showInfo(
                                                    {
                                                        name: $t(
                                                            'clp.LastPurchase'
                                                        ),
                                                        info: this
                                                            .personCardInfoTexts
                                                            .lastPurchase,
                                                    },
                                                    $event
                                                )
                                            "
                                            @mouseout="showInfo(false, $event)"
                                            >info</i
                                        >
                                    </div>
                                </div>
                                <div class="list">
                                    <div class="list-content">
                                        <div class="list-subheadline">
                                            {{ $t("clp.Membership") }}
                                        </div>
                                        <div class="list-row">
                                            <div>Status</div>
                                            <div>
                                                {{
                                                    currentPerson?.data?.person
                                                        ?.subscriptions[0]
                                                        ?.state ?? "-"
                                                }}
                                            </div>
                                        </div>
                                        <div class="list-row">
                                            <div>
                                                {{ $t("clp.Membership") }}
                                            </div>
                                            <div>
                                                {{
                                                    currentPerson?.data?.person
                                                        ?.subscriptions[0]
                                                        ?.product?.name ?? "-"
                                                }}
                                            </div>
                                        </div>
                                        <div class="list-row">
                                            <div>
                                                {{ $t("clp.MembershipType") }}
                                            </div>
                                            <div>
                                                {{
                                                    currentPerson?.data?.person
                                                        ?.subscriptions[0]
                                                        ?.product?.type ?? "- "
                                                }}
                                            </div>
                                        </div>
                                        <div class="list-row">
                                            <div>
                                                {{ $t("clp.BindingTime") }}
                                            </div>
                                            <div>
                                                <span
                                                    v-if="
                                                        currentPerson?.data
                                                            ?.person
                                                            ?.subscriptions[0]
                                                            ?.bindingEndDate
                                                    "
                                                ></span>
                                                {{
                                                    currentPerson?.data?.person
                                                        ?.subscriptions[0]
                                                        ?.bindingEndDate ?? "-"
                                                }}
                                            </div>
                                        </div>

                                        <div class="list-row">
                                            <div>
                                                {{ $t("clp.Enddate") }}
                                            </div>
                                            <div>
                                                <span
                                                    v-if="
                                                        currentPerson?.data
                                                            ?.person
                                                            ?.subscriptions[0]
                                                            ?.endDate
                                                    "
                                                ></span>
                                                {{
                                                    currentPerson?.data?.person
                                                        ?.subscriptions[0]
                                                        ?.endDate ?? "-"
                                                }}
                                            </div>
                                        </div>

                                        <div class="list-row">
                                            <div>{{ $t("clp.Gym") }}</div>
                                            <div>
                                                {{
                                                    currentPerson?.data?.person
                                                        ?.subscriptions[0]
                                                        ?.subscriptionId
                                                        ?.center ?? "-"
                                                }}
                                            </div>
                                        </div>
                                        <div class="list-row">
                                            <div
                                                v-if="
                                                    currentPerson?.data?.person
                                                        ?.subscriptions[0]
                                                        ?.product?.type !==
                                                    'CASH'
                                                "
                                            >
                                                {{ $t("clp.MonthlyFee") }}
                                            </div>
                                            <div
                                                v-if="
                                                    currentPerson?.data?.person
                                                        ?.subscriptions[0]
                                                        ?.product?.type ===
                                                    'CASH'
                                                "
                                            >
                                                {{ $t("clp.Price") }}
                                            </div>
                                            <div>
                                                {{
                                                    currentPerson?.data?.person
                                                        ?.subscriptions[0]
                                                        ?.price ?? "-"
                                                }}
                                            </div>
                                        </div>
                                        <div class="list-row">
                                            <div>
                                                {{ $t("clp.PurchaseLocation") }}
                                            </div>
                                            <div>-</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="list">
                                    <div class="list-subheadline">
                                        {{ $t("clp.Course") }}
                                    </div>
                                    <div class="list-row">
                                        <div>{{ $t("clp.Type") }}</div>
                                        <div v-if="!personExistInExerp">-</div>
                                        <div
                                            v-else-if="currentPerson.clipcards"
                                        >
                                            {{
                                                currentPerson.clipcards
                                                    ?.courses[0]
                                                    ?.clipcardTypeName !==
                                                undefined
                                                    ? currentPerson.clipcards
                                                          ?.courses[0]
                                                          ?.clipcardTypeName
                                                    : "-"
                                            }}
                                        </div>
                                        <div v-else>
                                            <div class="loading-spinner"></div>
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>{{ $t("clp.Date") }}</div>
                                        <div v-if="!personExistInExerp">-</div>
                                        <div
                                            v-else-if="currentPerson.clipcards"
                                        >
                                            {{
                                                currentPerson.clipcards
                                                    ?.courses[0]?.sales
                                                    ?.transactionTime !==
                                                undefined
                                                    ? currentPerson.clipcards
                                                          ?.courses[0]?.sales
                                                          ?.transactionTime
                                                    : "-"
                                            }}
                                        </div>
                                        <div v-else>
                                            <div class="loading-spinner"></div>
                                        </div>
                                    </div>
                                    <div class="list-row">
                                        <div>
                                            {{ $t("clp.PurchaseLocation") }}
                                        </div>
                                        <div v-if="!personExistInExerp">-</div>
                                        <div
                                            v-else-if="currentPerson.clipcards"
                                        >
                                            {{
                                                currentPerson.clipcards
                                                    ?.courses[0]?.sales
                                                    ?.placeOfPurchase !==
                                                undefined
                                                    ? currentPerson.clipcards
                                                          ?.courses[0]?.sales
                                                          ?.placeOfPurchase
                                                    : "-"
                                            }}
                                        </div>
                                        <div v-else>
                                            <div class="loading-spinner"></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="list-subheadline">
                                    {{ $t("clp.Clipcard") }}
                                </div>
                                <div class="list-row">
                                    <div>{{ $t("clp.Type") }}</div>
                                    <div v-if="!personExistInExerp">-</div>
                                    <div v-else-if="currentPerson.clipcards">
                                        {{
                                            currentPerson.clipcards
                                                ?.clipcards[0]
                                                ?.clipcardTypeName !== undefined
                                                ? currentPerson.clipcards
                                                      ?.clipcards[0]
                                                      ?.clipcardTypeName
                                                : "-"
                                        }}
                                    </div>
                                    <div v-else>
                                        <div class="loading-spinner"></div>
                                    </div>
                                </div>
                                <div class="list-row">
                                    <div>{{ $t("clp.Date") }}</div>
                                    <div v-if="!personExistInExerp">-</div>
                                    <div v-else-if="currentPerson.clipcards">
                                        {{
                                            currentPerson.clipcards
                                                ?.clipcards[0]?.sales
                                                ?.transactionTime !== undefined
                                                ? currentPerson.clipcards
                                                      ?.clipcards[0]?.sales
                                                      ?.transactionTime
                                                : "-"
                                        }}
                                    </div>
                                    <div v-else>
                                        <div class="loading-spinner"></div>
                                    </div>
                                </div>
                                <div class="list-row">
                                    <div>{{ $t("clp.PurchaseLocation") }}</div>
                                    <div v-if="!personExistInExerp">-</div>
                                    <div v-else-if="currentPerson.clipcards">
                                        {{
                                            currentPerson.clipcards
                                                ?.clipcards[0]?.sales
                                                ?.placeOfPurchase !== undefined
                                                ? currentPerson.clipcards
                                                      ?.clipcards[0]?.sales
                                                      ?.placeOfPurchase
                                                : "-"
                                        }}
                                    </div>
                                    <div v-else>
                                        <div class="loading-spinner"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="person-card-footer">
                    <div class="person-card-footer-buttons button-holder-right">
                        <div
                            v-if="
                                currentPerson?.data?.clp_data
                                    ?.contactedToday === false
                            "
                            class="button"
                            @click="openShowChangeStatusModal()"
                        >
                            {{ $t("clp.CallOutcome") }}
                        </div>
                        <div
                            v-if="
                                currentPerson?.data?.clp_data
                                    ?.contactedToday !== false
                            "
                            class="button button-disabled"
                            @click="openShowChangeStatusModal()"
                        >
                            {{ $t("clp.CallOutcome") }}
                        </div>
                        <div class="button" @click="closeCurrentPerson()">
                            {{ $t("clp.Cancel") }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-holder" v-show="showChangeStatusModal">
            <div class="modal-item">
                <div class="modal-item-header">
                    <h2>{{ $t("clp.CallOutcome") }}</h2>
                </div>
                <div class="modal-content scroll-bar">
                    <div class="input-holder">
                        <label>{{ $t("clp.Outcome") }}</label>
                        <div class="select-holder">
                            <select
                                v-model="status"
                                @change="updateOutcomeStatus()"
                            >
                                <option
                                    v-for="actionCategory in currentActions"
                                    :value="actionCategory.id"
                                >
                                    {{ actionCategory.name }}
                                </option>
                            </select>
                            <i
                                class="material-icons icon-rock pointer dropdown-arrow"
                                >arrow_drop_down</i
                            >
                        </div>
                    </div>

                    <div class="person-card-action">
                        <div class="input-holder">
                            <label>{{ $t("clp.Action") }}</label>

                            <div class="select-holder">
                                <select
                                    v-model="currentAction"
                                    @change="updateActionStatus()"
                                >
                                    <option
                                        v-for="action in currentActions[status]
                                            ?.actions"
                                        :value="action.id"
                                    >
                                        {{ action.name }}
                                    </option>
                                </select>
                                <i
                                    class="material-icons icon-rock pointer dropdown-arrow"
                                    >arrow_drop_down</i
                                >
                            </div>
                        </div>
                    </div>

                    <div class="person-card-action">
                        <div class="input-holder">
                            <label>{{ $t("clp.DaysToNextAction") }}</label>
                            <div class="litepicker-holder">
                                <input type="text" id="litepicker" />
                                <div
                                    v-if="
                                        currentDueDays !== 0 ||
                                        (currentDueDays === 0 &&
                                            handleLeadLater)
                                    "
                                    class="litepicker-date"
                                    @click="datePicker.show()"
                                >
                                    {{ currentDueDays }} ({{ currentDueDate }})
                                </div>
                                <div
                                    v-if="
                                        currentDueDays === 0 && !handleLeadLater
                                    "
                                    class="litepicker-date"
                                >
                                    {{ $t("clp.NoNextAction") }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Change status footer -->
                    <div class="input-holder">
                        <label>{{ $t("clp.Comment") }}</label>
                        <input type="text" v-model="currentComment" />
                    </div>

                    <div class="input-holder">
                        <label>{{ $t("clp.User") }}</label>
                        <span class="bold mt-1">{{ authStore.user.name }}</span>
                    </div>
                </div>
                <div class="button-holder-right modal-buttons">
                    <button
                        class="button button-transparent"
                        @click="showChangeStatusModal = false"
                    >
                        {{ $t("clp.Cancel") }}
                    </button>
                    <div v-if="currentAction === missedCallId" class="flex">
                        <div
                            v-if="currentPerson?.data?.clp_data?.can_send_sms"
                            class="button"
                            @click="showSMSModal = true"
                        >
                            {{ $t("clp.SendSMS") }}
                        </div>

                        <div
                            v-if="!currentPerson?.data?.clp_data?.can_send_sms"
                            class="button button-disabled"
                        >
                            {{ $t("clp.SendSMS") }}
                        </div>
                    </div>

                    <button class="button" @click="saveAction()">
                        {{ $t("clp.SaveAndNext") }}
                    </button>
                </div>
            </div>
        </div>

        <!-- Journal and notes -->
        <div class="modal-holder" v-if="showJournalNotes">
            <div class="modal-info-card">
                <div class="person-card-header">
                    <h2>{{ $t("clp.JournalAndNotes") }}</h2>
                    <div class="modal-close" @click="showJournalNotes = false">
                        <img src="/assets/icon-close.svg" />
                    </div>
                </div>
                <div class="modal-content">
                    <div
                        class="journal-note-item"
                        v-for="journalNote in currentPerson?.journalNotes"
                    >
                        <div class="journal-date">
                            {{ journalNote.creationDate }} -
                            {{ journalNote.creationTime }}
                        </div>
                        <div class="journal-note">
                            {{ formatJournalDate(journalNote?.text) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Logbook -->
        <div class="modal-holder" v-if="showLogs">
            <div class="modal-info-card">
                <div class="person-card-header">
                    <h2>{{ $t("clp.ContactLog") }}</h2>
                    <div class="modal-close" @click="showLogs = false">
                        <img src="/assets/icon-close.svg" />
                    </div>
                </div>
                <div class="modal-content">
                    <div v-for="logItem in currentPerson?.data?.logs">
                        <div class="journal-note-item">
                            <div class="journal-date">
                                {{ logItem.date }} {{ logItem.time }}
                                {{ getDatePrefix(logItem.daysSinceLog) }}
                            </div>
                            <div class="journal-note">
                                <span v-if="logItem.outcome !== ''">
                                    {{
                                        getTranslation(
                                            "actions_categories",
                                            logItem.outcome_id
                                        )
                                    }}
                                    <i class="log-arrow material-icons arrow"
                                        >east</i
                                    >
                                    {{
                                        getTranslation(
                                            "actions",
                                            logItem.action_id
                                        )
                                    }}
                                    <br />
                                </span>
                                {{ $t("clp.Comment") }}: {{ logItem.comment
                                }}<br />
                                {{ $t("clp.Type") }}:
                                {{ getTranslation("types", logItem.type)
                                }}<br />
                                <span v-if="logItem.handled_by">
                                    {{ $t("clp.User") }}:
                                    {{ logItem.handled_by }}</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Send SMS -->
        <div class="modal-holder" v-if="showSMSModal">
            <div class="modal-item">
                <div class="modal-item-header">
                    <h2>{{ $t("clp.SendSMS") }}</h2>
                </div>
                <div class="modal-content scroll-bar">
                    <div class="input-holder">
                        <label>{{ $t("clp.To") }}</label>
                        <span class="bold">
                            {{ currentPerson?.data?.person?.person?.firstName }}
                            {{ currentPerson?.data?.person?.person?.lastName }}
                        </span>
                    </div>

                    <div class="input-holder">
                        <label>{{ $t("clp.Type") }}</label>
                        <span class="bold">
                            {{ currentPerson?.data?.clp_data?.type }}
                        </span>
                    </div>

                    <div class="input-holder">
                        <label>{{ $t("clp.Message") }}</label>
                        <select
                            v-model="currentSelectedSmsText"
                            @change="updateSmsText()"
                        >
                            <option
                                :value="index"
                                v-for="(sms, index) in allSmsTexts"
                            >
                                {{ sms.title }}
                            </option>
                        </select>
                    </div>

                    <div class="input-holder">
                        <p>
                            {{ allSmsTexts[currentSelectedSmsText].text }}
                        </p>
                    </div>
                </div>
                <div class="button-holder-right modal-buttons">
                    <div
                        class="button button-transparent"
                        @click="showSMSModal = false"
                    >
                        {{ $t("clp.Cancel") }}
                    </div>
                    <div class="button" @click="sendSMS()">
                        {{ $t("clp.Send") }}
                    </div>
                </div>
            </div>
        </div>
    </main>

    <!-- Info modal -->

    <div
        class="modal-holder modal-info-texts"
        v-if="currentContentInInfoModal !== false"
    >
        <div class="modal-card">
            <div
                class="modal-content scroll-bar"
                v-html="currentContentInInfoModal"
            ></div>
            <div class="modal-buttons">
                <div class="buttons button-holder-right">
                    <div
                        class="button"
                        @click="currentContentInInfoModal = false"
                    >
                        {{ $t("clp.Close") }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Transition name="fade">
        <div class="person-success" v-if="showPersonSuccess !== false">
            <div class="person-success-content">
                <i class="material-icons-outlined icon-success">check_circle</i>
                <div>{{ $t("clp.PersonSaved") }}</div>
            </div>
        </div>
    </Transition>

    <Transition name="fade">
        <div class="modal-holder" v-if="showSMSSuccess !== false">
            <div class="person-success">
                <div class="person-success-content">
                    <i class="material-icons-outlined icon-success"
                        >check_circle</i
                    >
                    <div>{{ $t("clp.SMSDone") }}</div>
                </div>
            </div>
        </div>
    </Transition>

    <div
        id="debug-date"
        v-if="authStore.user.privileges.includes('change_day')"
    >
        Nuvarande datum: {{ current_debug_date }}<br />
        <a href="/app/clp/next-day/89wefhbweufgubdvwfc" class="button-text"
            >DEBUG: Flytta fram en dag</a
        >
    </div>

    <div class="tooltip" :class="'placement_' + tooltipPlacement">
        <h3>{{ tooltipItem.name }}</h3>
        <p>{{ tooltipItem.info }}</p>
    </div>
</template>
<script>
import axios from "axios";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import Litepicker from "litepicker";
import { mapStores } from "pinia";
import { useAuthStore } from "../../stores/auth.js";
import FirstLoginModal from "./FirstLoginModal.vue";
import moment from "moment";

/*
import Echo from "laravel-echo";
import Pusher from "pusher-js";
window.Pusher = Pusher;

Pusher.logToConsole = true;

window.Echo = new Echo({
    broadcaster: "pusher",
    key: "85861146a7d9e5ddba85",
    cluster: "eu",
    forceTLS: false,
    encrypted: true,
    authEndpoint: `https://actic-admin.texasdigital.se/broadcasting/auth`,
    auth: {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
        },
    },
});
*/

export default {
    components: {
        FirstLoginModal,
    },
    computed: {
        ...mapStores(useAuthStore),
    },
    data() {
        return {
            loading: true,
            board: [],
            currentStats: {},
            currentPerson: {},
            currentBoard: 0,
            currentKey: 0,
            status: "missed_call",
            loadingChangeStatus: false,
            showChangeStatusModal: false,
            currentBoardIndex: 0,
            currentBoardId: 0,
            actions: [],
            centers: [],
            currentAction: "",
            currentUserId: 0,
            currentActions: [],
            currentComment: "",
            currentDueDate: "",
            currentDueDays: 1,
            showBoard: false,
            axiosController: {},
            showJournalNotes: false,
            showLogs: false,
            datePicker: false,
            current_debug_date: Date("Y-m-d"),
            tooltipX: "-1000px",
            tooltipY: "-1000px",
            tooltipDisplay: "flex",
            tooltipItem: {},
            showSMSModal: false,
            numberOfTodosToShow: 10,
            sortOrder: [],
            mappedCategories: {},
            tooltipPlacement: "top",
            personExistInExerp: false,
            currentContentInInfoModal: false,
            showPersonCard: false,
            showPersonSuccess: false,
            showPersonSuccessFade: false,
            currentCardInfo: {},
            showSuccess: false,
            showSMSSuccess: false,
            personCardInfoTexts: {
                personData: "",
                visitHistory: "",
                lastPurchase: "",
                sellMembership: "",
            },
            search: {
                name: "",
                memberNumber: "",
                phone: "",
            },
            findLeadIsLoading: false,
            searchResults: [],
            searchResultEmpty: false,
            types: {},
            missedCallId: 0,
            missedCallSMSText: "",
            showNextCard: true,
            handleLeadLater: false,
            dueDateCanBeZero: false,
            allSmsTexts: [],
            currentSelectedSmsText: 0,
            translations: {},
        };
    },
    created() {
        const escapeHandler = (e) => {
            if (this.currentPerson && !this.loading && e.key === "Escape") {
                this.closeCurrentPerson();
            }
        };
        document.addEventListener("keydown", escapeHandler);
    },

    methods: {
        buildSalesUrl() {
            const params = [];
            const person = this.currentPerson?.data?.person?.person;
            const communication = this.currentPerson?.data?.person?.personCommunication;

            if (person?.firstName) {
                params.push(`name=${encodeURIComponent(person.firstName)}`);
            }
            if (person?.lastName) {
                params.push(`lastname=${encodeURIComponent(person.lastName)}`);
            }
            if (communication?.mobilePhoneNumber) {
                params.push(`phone=${encodeURIComponent(communication.mobilePhoneNumber)}`);
            }
            if (communication?.email) {
                params.push(`email=${encodeURIComponent(communication.email)}`);
            }

            const queryString = params.join('&');
            const url = `/app/sales?${queryString}`;
            return url;
        },
        translateType(type) {
            if (this.translations.types?.[type] !== undefined) {
                return this.translations.types?.[type];
            }
            return type;
        },
        getTranslation(type, key) {
            if (this.translations?.[type]?.[key] !== undefined) {
                return this.translations?.[type]?.[key];
            }
            return key;
        },
        getTypeInfoText(type) {
            // Find the type in the types object
            let typeObject = this.types.find((element) => {
                return element.name === type;
            });

            return {
                name: typeObject.name,
                info: typeObject.info,
            };
        },
        showFindedPersonCard(externalId) {
            let self = this;
            this.loading = true;

            // Check if the person exist in the lead system
            let thePerson = this.findPersonByExternalId(externalId);

            if (thePerson !== null) {
                self.showCard(
                    null,
                    thePerson.person.CLP_Session_id,
                    thePerson.board,
                    thePerson.category,
                    thePerson.lead,
                    self.board[thePerson.board].categories[thePerson.category]
                        .newActions,
                    false,
                    false
                );
                return;
            }

            axios
                .get(self.authStore.api + "/clp/get-person/" + externalId, {
                    headers: {
                        Authorization: "Bearer " + self.authStore.token,
                    },
                })
                .then((response) => {
                    self.loading = false;

                    if (
                        response.data.person?.person?.personId?.center !==
                        undefined
                    ) {
                        let personKey =
                            response.data.person?.person?.personId?.center +
                            "p" +
                            response.data.person?.person?.personId?.id;
                        self.personExistInExerp = true;
                        this.getLastParticipations(personKey);
                        this.getLastCheckin(personKey);
                        this.getClipcards(personKey);
                        this.getJournalNotes(personKey);
                        this.getQRCheckin(
                            response.data.person?.person?.personId?.externalId
                        );
                    }

                    self.currentPerson.data = response.data;
                    self.showPersonCard = true;
                })
                .catch((error) => {
                    this.loading = false;
                });
        },
        findLeads() {
            this.findLeadIsLoading = true;
            this.searchResults = [];
            this.searchResultEmpty = false;
            let self = this;

            axios
                .post(
                    self.authStore.api + "/clp/find-persons",
                    {
                        name: self.search.name,
                        personKey: self.search.personKey,
                        phone: self.search.phone,
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                    }
                )
                .then((response) => {
                    self.findLeadIsLoading = false;
                    self.searchResults = response.data;

                    if (self.searchResults.length === 0) {
                        self.searchResultEmpty = true;
                    }
                })
                .catch((error) => {
                    this.loading = false;
                });
        },
        getNewLead() {
            let index = this.board[this.currentUserId.board].categories[
                this.currentUserId.category
            ].items.findIndex((element) => {
                return element.last_outcome === null;
            });

            if (index === -1) {
                return false;
            }

            return this.board[this.currentUserId.board].categories[
                this.currentUserId.category
            ].items[index];
        },

        showInfoInModal(boardItem, event) {
            this.currentContentInInfoModal = boardItem.info;
        },
        formatJournalDate(note) {
            if (note === null || note === undefined) {
                return "";
            }

            return note.replace(
                /[0-9]{4}-[0-9]{2}-[0-9]{2}\s[0-9]{2}:[0-9]{2}:[0-9]{2}\s-\s/g,
                ""
            );
        },
        updateActionStatus() {
            let key = this.currentActions[this.status].actions.findIndex(
                (action) => {
                    return action.id === this.currentAction;
                }
            );
            this.updateTheDueDate(key);
        },
        updateOutcomeStatus() {
            this.handleLeadLater = false;
            this.dueDateCanBeZero = false;
            this.updateTheDueDate(0);
        },
        updateTheDueDate(actionKey) {
            this.currentAction =
                this.currentActions[this.status].actions[actionKey].id;

            this.currentDueDays =
                this.currentActions[this.status].actions[
                    actionKey
                ].days_to_take_actions;

            let date = new Date(this.current_debug_date);
            date.setDate(date.getDate() + this.currentDueDays);
            this.datePicker.setDate(date.toISOString().split("T")[0]);
            this.currentDueDate = date.toISOString().split("T")[0];
        },
        sortLeads(items) {
            // How do we sort by priority score here?
            if (items === undefined) {
                return [];
            }

            let sorted = [];
            let i = 0;

            // Check if the lead is in the first 10 sort items (numberOfTodosToShow)
            items.forEach((item) => {
                let i = this.sortOrder.findIndex(
                    (element) => element.CLP_Session_id === item.CLP_Session_id
                );

                if (i < this.numberOfTodosToShow) {
                    sorted.push(item);
                }
            });

            return sorted;

            //return items;
        },
        findPerson(personkey) {
            // Iterate over all boards
            for (let board of this.board) {
                // Iterate over all categories in the current board
                for (let category of board.categories) {
                    // Find the person in the current category
                    let person = category.items.find((p) => {
                        return p.personkey === personkey;
                    });
                    if (person) {
                        return person;
                    }
                }
            }
            // Return null if no person was found
            return null;
        },
        findPersonByExternalId(externalId) {
            // Iterate over all boards
            for (let board of this.board) {
                // Iterate over all categories in the current board
                for (let category of board.categories) {
                    // Find the person in the current category
                    if (category.items === undefined) {
                        continue;
                    }
                    let person = category.items.find((p) => {
                        return p.external_id === externalId;
                    });
                    if (person) {
                        return {
                            board: this.board.indexOf(board),
                            category: board.categories.indexOf(category),
                            lead: category.items.indexOf(person),
                            person: person,
                        };
                    }
                }
            }

            // Return null if no person was found
            return null;
        },
        loadNewLeads() {
            let self = this;
            axios
                .post(
                    self.authStore.api + "/clp/leads/getUpdates",
                    {},
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                    }
                )
                .then((response) => {
                    response.data.leads.forEach(function (lead) {
                        if (self.board[0].categories[0].items === undefined) {
                            self.board[0].categories[0].items = [];
                        }

                        self.sortOrder.push({
                            personkey: lead.personkey,
                        });

                        self.board[0].categories[0].items.push(lead);
                    });

                    toast("Nya leads kom in!", {
                        type: "success",
                        position: "bottom-right",
                        autoClose: 1000,
                        dangerouslySetInnerHTML: true,
                    });
                })
                .catch((error) => {
                    this.loading = false;
                });
        },
        formatDate(date) {
            if (date) {
                let startDate = new Date(date);
                let dateToday = new Date();
                const diffInDays = moment(dateToday).diff(
                    moment(startDate),
                    "days"
                );

                if (diffInDays === 0) {
                    return (
                        date.substring(2) + " (" + this.$t("clp.today") + ")"
                    );
                } else if (diffInDays === 1) {
                    return (
                        date.substring(2) +
                        " (" +
                        this.$t("clp.yesterday") +
                        ")"
                    );
                } else {
                    return date.substring(2) + " (" + diffInDays + ")";
                }
            }
        },
        sendSMS() {
            this.loading = true;
            let self = this;

            axios
                .post(
                    self.authStore.api + "/clp/lead/sendSMS",
                    {
                        lead: self.currentPerson.data.clp_data.CLP_Session_id,
                        messageId: self.currentSelectedSmsText,
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                    }
                )
                .then((response) => {
                    self.loading = false;
                    self.showSMSModal = false;

                    this.showSMSSuccess = true;

                    setTimeout(function () {
                        self.showSMSSuccess = false;
                    }, 1000);

                    let date = new Date(this.current_debug_date);

                    self.board[self.currentUserId.board].categories[
                        self.currentUserId.category
                    ].items[self.currentUserId.lead].sms_sended = date
                        .toISOString()
                        .split("T")[0];

                    self.currentPerson.data.clp_data.sms_sended = date
                        .toISOString()
                        .split("T")[0];

                    self.board[self.currentUserId.board].categories[
                        self.currentUserId.category
                    ].items[self.currentUserId.lead].can_send_sms = false;

                    self.currentPerson.data.clp_data.can_send_sms = false;

                    toast("SMS skickat!", {
                        type: "success",
                        position: "bottom-right",
                        autoClose: 1000,
                        dangerouslySetInnerHTML: true,
                    });
                })
                .catch((error) => {
                    this.loading = false;
                });
        },
        showInfo(boardItem, event) {
            var rect = event.target.getBoundingClientRect();
            this.tooltipItem = boardItem;

            if (boardItem) {
                let that = this;

                setTimeout(function () {
                    let heightOfTooltip = document
                        .querySelector(".tooltip")
                        .getBoundingClientRect();
                    that.tooltipDisplay = "flex";
                    that.tooltipX = rect.x - 115 + "px";

                    if (rect.y > heightOfTooltip.height) {
                        that.tooltipPlacement = "top";
                        that.tooltipY =
                            rect.y - heightOfTooltip.height - 26 + "px";
                    } else {
                        that.tooltipPlacement = "bottom";
                        that.tooltipY = rect.y + 46 + "px";
                    }
                }, 1);
            } else {
                this.tooltipX = "-1000px";
                this.tooltipY = "-1110px";
                this.tooltipDisplay = "flex";
            }
        },
        getDaysBetweenDates(date1, date2) {
            const oneDay = 1000 * 60 * 60 * 24;
            const diffInMilliseconds = Math.abs(date2 - date1);
            return Math.round(diffInMilliseconds / oneDay);
        },
        getDatePrefix(days) {
            if (days === undefined) {
                return "";
            }

            switch (days) {
                case 0:
                    return "(" + this.$t("clp.today") + ")";
                case 1:
                    return "(" + this.$t("clp.yesterday") + ")";
                default:
                    return "(" + days + " " + this.$t("clp.days") + ")";
            }
        },

        openShowChangeStatusModal() {
            // Set the first items as default
            this.status = Object.keys(this.currentActions)[0];
            this.updateOutcomeStatus();
            this.currentComment = "";
            this.showChangeStatusModal = true;
        },
        updateDueDateByStatus() {
            return 1;
            let date = new Date(this.current_debug_date);
            if (this.status === "missed_call") {
                date.setDate(date.getDate() + 1);
                this.currentDueDate = date.toISOString().split("T")[0];
                this.datePicker.setDate(date.toISOString().split("T")[0]);
                this.currentDueDays = 1;
            } else {
                this.currentAction = this.currentActions[0].id;
                this.updateDueDate();
            }
        },
        closeCurrentPerson() {
            // Abort all axios requests for person and close the modal
            if (this.axiosController.getPerson !== undefined) {
                this.axiosController.getPerson.abort();
            }

            if (this.axiosController.getLastParticipations !== undefined) {
                this.axiosController.getLastParticipations.abort();
            }

            if (this.axiosController.getLastCheckin !== undefined) {
                this.axiosController.getLastCheckin.abort();
            }

            if (this.axiosController.getClipcards !== undefined) {
                this.axiosController.getClipcards.abort();
            }

            if (this.axiosController.getJournalNotes !== undefined) {
                this.axiosController.getJournalNotes.abort();
            }

            /*
            if (this.axiosController.lockLead !== undefined) {
                this.axiosController.lockLead.abort();
            }
            */

            if (this.axiosController.getQRCheckin !== undefined) {
                this.axiosController.getQRCheckin.abort();
            }

            this.showChangeStatusModal = false;

            //this.unlockLead(this.currentPerson.data.clp_data.personkey);

            this.currentPerson = {};
            this.showPersonCard = false;
            let self = this;
        },
        updateDueDate() {
            return;
            let action = this.currentActions.find(
                (element) => element.id === this.currentAction
            );
            let date = new Date(this.current_debug_date);
            date.setDate(date.getDate() + action.dueDate);
            this.currentDueDays = action.dueDate;
            this.datePicker.setDate(date.toISOString().split("T")[0]);
            this.currentDueDate = date.toISOString().split("T")[0];
        },
        changeBoard(index) {
            this.loading = true;
            this.showBoard = false;
            this.currentBoardIndex = index;
            this.currentBoardId = this.board[this.currentBoardIndex].id;

            let self = this;
            setTimeout(function () {
                self.showBoard = true;
                self.loading = false;
            }, 200);
        },

        saveAction() {
            this.loading = true;
            this.showChangeStatusModal = false;
            let self = this;
            let action = false;
            let handleLeadLater = false;

            if (this.currentDueDays === 0 && this.handleLeadLater) {
                handleLeadLater = true;
            }

            action = this.currentAction;

            axios
                .post(
                    self.authStore.api + "/clp/lead/updateStatus",
                    {
                        id: this.currentUserId.id,
                        outcome: this.status,
                        action: action,
                        comment: this.currentComment,
                        dueDate: this.currentDueDate,
                        handleLeadLater: handleLeadLater,
                        centerId: this.authStore.user.current_center.center_id,
                        numberOfLeads:
                            this.currentStats[
                                this.authStore.user.current_center.center_id
                            ].number_of_leads,
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                    }
                )
                .then((response) => {
                    this.loading = false;
                    self.showPersonSuccess = true;

                    let theUser =
                        self.board[self.currentUserId.board].categories[
                            self.currentUserId.category
                        ].items[self.currentUserId.lead];
                    self.board[self.currentUserId.board].categories[
                        self.currentUserId.category
                    ].items[self.currentUserId.lead].outcome_action_id =
                        self.currentAction;
                    self.board[self.currentUserId.board].categories[
                        self.currentUserId.category
                    ].items.splice(self.currentUserId.lead, 1);
                    theUser.last_outcome = self.status;
                    theUser.last_outcome_action = response.data.action;

                    if (handleLeadLater) {
                        theUser.handle_later = 1;
                    } else {
                        theUser.handle_later = 0;
                    }

                    self.board[self.currentUserId.board].categories[
                        self.currentUserId.category
                    ].items.push(theUser);

                    let newLead = false;

                    if (self.showNextCard) {
                        newLead = self.getNewLead();
                    }

                    self.showPersonCard = false;

                    setTimeout(function () {
                        if (newLead !== false) {
                            self.showCard(
                                newLead.being_edited_by_id,
                                newLead.CLP_Session_id,
                                false,
                                false,
                                false,
                                false,
                                true
                            );
                        } else {
                            self.showPersonSuccess = false;
                            self.closeCurrentPerson();
                        }
                    }, 1000);

                    toast("Status sparad! Bra jobbat!", {
                        type: "success",
                        position: "bottom-right",
                        autoClose: 1000,
                        dangerouslyHTMLString: true,
                    });
                    self.currentStats = response.data.stats;
                })
                .catch((error) => {
                    this.loading = false;
                });
        },
        getLastParticipations(id) {
            this.controller = new AbortController();
            this.axiosController.getLastParticipations = new AbortController();
            let self = this;

            axios
                .get(
                    self.authStore.api +
                        "/clp/lead/" +
                        id +
                        "/info/lastParticipations",
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                        signal: self.axiosController.getLastParticipations
                            .signal,
                    }
                )
                .then((response) => {
                    self.currentPerson.lastParticipations = response.data;
                })
                .catch((error) => {});
        },

        getLastCheckin(id) {
            this.axiosController.getLastCheckin = new AbortController();
            let self = this;

            axios
                .get(
                    self.authStore.api +
                        "/clp/lead/" +
                        id +
                        "/info/lastCheckin",
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                        signal: self.axiosController.getLastCheckin.signal,
                    }
                )
                .then((response) => {
                    self.currentPerson.lastCheckin = response.data;
                })
                .catch((error) => {});
        },

        lockLead(id) {
            this.axiosController.lockLead = new AbortController();
            let self = this;

            axios
                .get(self.authStore.api + "/clp/lead/" + id + "/lock", {
                    headers: {
                        Authorization: "Bearer " + self.authStore.token,
                    },
                    signal: self.axiosController.lockLead.signal,
                })
                .then((response) => {
                    console.log(response);
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        unlockLead(id) {
            this.axiosController.unlockLead = new AbortController();
            let self = this;

            axios
                .get(self.authStore.api + "/clp/lead/" + id + "/unlock", {
                    headers: {
                        Authorization: "Bearer " + self.authStore.token,
                    },
                    signal: self.axiosController.unlockLead.signal,
                })
                .then((response) => {
                    console.log(response);
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        getClipcards(id) {
            this.axiosController.getClipcards = new AbortController();
            let self = this;

            axios
                .get(
                    self.authStore.api + "/clp/lead/" + id + "/info/clipcards",
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                        signal: self.axiosController.getClipcards.signal,
                    }
                )
                .then((response) => {
                    self.currentPerson.clipcards = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        getJournalNotes(id) {
            this.axiosController.getJournalNotes = new AbortController();
            let self = this;

            axios
                .get(
                    self.authStore.api +
                        "/clp/lead/" +
                        id +
                        "/info/journalNotes",
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                        signal: self.axiosController.getJournalNotes.signal,
                    }
                )
                .then((response) => {
                    self.currentPerson.journalNotes = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        getQRCheckin(externalId) {
            console.log("getQRCheckin");
            this.axiosController.getQRCheckin = new AbortController();
            let self = this;

            axios
                .get(
                    self.authStore.api +
                        "/clp/lead/" +
                        externalId +
                        "/info/QRCodeCheckin",
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                        signal: self.axiosController.getJournalNotes.signal,
                    }
                )
                .then((response) => {
                    if (response.data.used !== undefined) {
                        self.currentPerson.usedQRCode = response.data.used;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        showCard(
            being_edited_by_id,
            id,
            boardKey,
            categoryKey,
            leadKey,
            actions,
            disableLoading,
            showNextCard
        ) {
            this.showNextCard = showNextCard;

            if (actions !== false) {
                this.currentCardInfo = {
                    boardKey: boardKey,
                    categoryKey: categoryKey,
                    leadKey: leadKey,
                    actions: actions,
                };
            } else {
                boardKey = this.currentCardInfo.boardKey;
                categoryKey = this.currentCardInfo.categoryKey;
                leadKey = this.currentCardInfo.leadKey;
                actions = this.currentCardInfo.actions;
            }

            if (
                being_edited_by_id !== null &&
                being_edited_by_id !== this.authStore.user.id
            ) {
                //return;
            }

            if (disableLoading === false) {
                this.loading = true;
            }

            let self = this;

            this.currentActions = actions;

            //this.status = 'missed_call';

            this.currentUserId = {
                id: id,
                board: boardKey,
                category: categoryKey,
                lead: leadKey,
            };

            //this.lockLead(id);
            self.personExistInExerp = false;
            this.axiosController.getPerson = new AbortController();

            // Get info about the person
            axios
                .get(self.authStore.api + "/clp/lead/" + id + "/info", {
                    headers: {
                        Authorization: "Bearer " + self.authStore.token,
                    },
                    signal: this.axiosController.getPerson.signal,
                })
                .then((response) => {
                    if (
                        response.data.person?.person?.personId?.center !==
                        undefined
                    ) {
                        let personKey =
                            response.data.person?.person?.personId?.center +
                            "p" +
                            response.data.person?.person?.personId?.id;
                        self.personExistInExerp = true;
                        this.getLastParticipations(personKey);
                        this.getLastCheckin(personKey);
                        this.getClipcards(personKey);
                        this.getJournalNotes(personKey);
                        this.getQRCheckin(
                            response.data.person?.person?.personId?.externalId
                        );
                    }

                    this.loading = false;
                    this.currentPerson.data = response.data;

                    if (disableLoading) {
                        self.showSuccess = true;
                        setTimeout(function () {
                            // Check if there is more leads in the array
                            self.showSuccess = false;
                            self.showPersonCard = true;
                            self.showPersonSuccess = false;
                        }, 200);
                    } else {
                        setTimeout(function () {
                            self.showPersonCard = true;
                        }, 20);
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    toast("Kunde inte hämta personen, försök igen senare.", {
                        type: "error",
                        position: "bottom-right",
                        autoClose: 1000,
                        dangerouslyHTMLString: true,
                    });
                });
        },

        loadLeadsByCenter() {
            this.loading = true;
            let self = this;
            /*
            if (self.authStore.user?.pre_center !== undefined) {
                window.Echo.leave(
                    "center-" + self.authStore.user.pre_center.center_id
                );
            }
            */
            axios
                .get(
                    self.authStore.api +
                        "/clp/leads/" +
                        self.authStore.user.current_center.center_id,
                    {
                        headers: {
                            Authorization: "Bearer " + self.authStore.token,
                        },
                    }
                )
                .then((response) => {
                    self.loading = false;

                    // Set translations
                    self.translations = response.data.translations;

                    // Set language
                    self.$i18n.locale = response.data.language;

                    // For missed call sms
                    self.missedCallId = response.data.missed_call_id;
                    self.missedCallSMSText = response.data.missed_call_sms_text;

                    self.allSmsTexts = response.data.sms_texts;

                    self.board = response.data.boards;

                    self.currentBoardId = self.board[0].id;

                    self.actions = response.data.actions;
                    self.showBoard = true;

                    // Load the stats
                    self.currentStats = response.data.stats;
                    self.current_debug_date = response.data.debug_current_date;

                    // Fix the sort thing
                    self.sortOrder = response.data.sort_order;

                    // Save the mapped categories
                    self.mappedCategories = response.data.mapped_categories;
                    self.numberOfTodosToShow =
                        self.authStore.user.current_center.number_of_todos;

                    if (response.data.person_card_info_text !== false) {
                        // Personcard info text
                        this.personCardInfoTexts =
                            response.data.person_card_info_text;
                    }

                    self.types = response.data.types;

                    // Load websocket
                    /*
                    window.Echo.private(
                        "center-" + self.authStore.user.current_center.center_id
                    ).listen(".new-leads", (e) => {
                        // Fetch new leads in the background and add it to the list!
                        //self.loadNewLeads();
                    });

                    window.Echo.private(
                        "center-" + self.authStore.user.current_center.center_id
                    ).listen(".lead-locked", (e) => {
                        // Lock the lead in the dashboard!
                        let person = self.findPerson(e.personkey);
                        person.being_edited = true;
                        person.being_edited_by = e.user;
                    });

                    window.Echo.private(
                        "center-" + self.authStore.user.current_center.center_id
                    ).listen(".lead-unlocked", (e) => {
                        // Lock the lead in the dashboard!
                        let person = self.findPerson(e.personkey);
                        person.being_edited = null;
                    });
                    */
                })
                .catch((error) => {
                    this.loading = false;
                });
        },

        changeStatus() {
            this.loadingChangeStatus = true;
            let newStatus = this.status;
            axios({
                method: "post",
                url: self.authStore.api + "/clp/lead/changeStatus",
                data: {
                    id: this.currentPerson.id,
                    status: newStatus,
                },
            }).then((response) => {
                this.loadingChangeStatus = false;
                let item =
                    this.board[this.currentBoard]["items"][this.currentKey];

                item.status = newStatus;

                if (newStatus == "processed") {
                    this.board[this.currentBoard]["items"].splice(
                        this.currentKey,
                        1
                    );
                    this.board[this.currentBoard]["items"].push(item);
                } else {
                    this.board[this.currentBoard]["items"].splice(
                        this.currentKey,
                        1
                    );
                    this.board[this.currentBoard]["items"].unshift(item);
                }
                this.currentPerson = {};

                toast("Status sparad! Bra jobbat!", {
                    type: "success",
                    position: "bottom-right",
                    autoClose: 1000,
                    dangerouslyHTMLString: true,
                });
            });
        },
    },
    mounted() {
        this.loadLeadsByCenter();
        let self = this;
        let date = new Date(this.current_debug_date);
        date.setDate(date.getDate() + 1);

        let startDate = new Date(this.current_debug_date);

        this.datePicker = new Litepicker({
            element: document.getElementById("litepicker"),
            lang: "SE-sv",
            minDate: startDate.toISOString().split("T")[0],
            startDate: date.toISOString().split("T")[0],
            setup: (picker) => {
                picker.on("selected", (date1) => {
                    let dateToday = new Date(self.current_debug_date);

                    // Check if the date is today
                    if (
                        date1.dateInstance.toDateString() ===
                            dateToday.toDateString() &&
                        self.dueDateCanBeZero === true
                    ) {
                        self.handleLeadLater = true;
                    }

                    let data = new Date(
                        date1.dateInstance.getTime() -
                            date1.dateInstance.getTimezoneOffset() * 60 * 1000
                    );
                    self.currentDueDate = data.toISOString().split("T")[0];
                    self.currentDueDays = self.getDaysBetweenDates(
                        dateToday,
                        date1.dateInstance
                    );
                });

                picker.on("show", () => {
                    self.dueDateCanBeZero = true;
                });
            },
        });
    },
};
</script>

<style>
body {
    background-color: #f2f2f2;
}

main {
    margin: 0 14px;
    @media (min-width: 1070px) {
        margin: 0 28px;
    }
}

.board {
    display: flex;
    height: 100%;
    margin-left: -30px;
    overflow: scroll;
}

.board-column {
    width: 315px;
    padding: 30px 30px 0 30px;
    min-height: 100vh;
    flex-shrink: 0;

    &:nth-child(even) {
        background-color: #eaecee;
    }
}

.board-item {
    width: 100%;
    background-color: #fff;
    margin-bottom: 20px;
    border-radius: 5px 0 0 5px;
    padding: 12px 10px 8px 10px;
    cursor: pointer;
    border-right: 10px solid #b1144e;
    box-shadow: 4px 4px 4px 0px #00000026;
    transition: all 0.2s ease;
    font-family: "helvetica-regular";
    letter-spacing: 1px;

    &:hover {
        background-color: #f6f6f6;
        transition: all 0.2s ease;
    }
}

.board-item-holder {
    position: relative;
}

.board-item-title {
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 1px;
    line-height: 26px;
    font-weight: 700;
    margin-bottom: 13px;
    font-family: "hansen-grotesque-bold", sans-serif;
}

.board-item-type {
    font-size: 15px;
    letter-spacing: 1px;
    margin-bottom: 19px;
}

.board-item-status {
    font-size: 15px;
    letter-spacing: 1px;
    color: #617594;
    margin-bottom: 12px;
}

.board-item-locked {
    width: 62px;
    height: 62px;
    overflow: hidden;
    background: #a1b1c8;
    border-radius: 100px;
    position: absolute;
    right: calc(50% - 31px);
    top: calc(50% - 31px);
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #fff;
    font-family: "hansen-grotesque-bold", sans-serif;
    font-size: 16px;
}

.list-move, /* apply transition to moving elements */
.list-enter-active,
.list-leave-active {
    transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
    opacity: 0;
    transform: translateX(30px);
}

/* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
.list-leave-active {
    position: absolute;
}

.board-item.processed {
    border-right: 10px solid #6fbf8f;
}

.board-item.handleLater {
    border-right: 10px solid #0033ff;
}

.board-item.being-edited {
    opacity: 0.2;
    cursor: default;
}

.list-row > div:first-child {
    font-family: "hansen-grotesque-bold", sans-serif;
    padding-right: 10px;
}

.loading {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100000;
}
.lds-ring {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}
.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 8px solid #fff;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}
@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.modal-holder {
    width: 100%;
    height: 100%;
    background-color: rgba(242, 242, 242, 0.7);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(4px);
    z-index: 1000;
}

.modal-close {
    width: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
}

.person-card {
    width: 1132px;
    max-width: calc(100% - 14px);
    padding: 10px 24px 22px 24px;
    background-color: #fff;
    border: 1px solid #617594;
    position: relative;
    display: flex;
    flex-direction: column;
    max-height: 90vh;
    box-shadow: 4px 4px 4px 0px #00000026;
    left: -100%;
    transition: all 1s ease;
    opacity: 0;
    overflow: hidden;

    &.show {
        left: 0;
        transition: all 1s ease;
        opacity: 1;
    }

    &.show-success {
        left: 100% !important;
        transition: none;
    }
}

.modal-info-card {
    width: 1132px;
    max-width: calc(100% - 14px);
    padding: 10px 24px 22px 24px;
    background-color: #fff;
    border: 1px solid #617594;
    position: relative;
    display: flex;
    flex-direction: column;
    max-height: 90vh;
    box-shadow: 4px 4px 4px 0px #00000026;
    left: 0;
    transition: all 1s ease;

    @media (min-width: 800px) {
        padding: 24px 24px 22px 24px;
    }
}

.person-card-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;
}

.person-card-image {
    width: 92px;
    height: 92px;

    border: 2px solid #b1144e;
    border-radius: 100%;
    margin-right: 20px;
    position: relative;
    left: -6px;
    top: 4px;
    background-color: #c4c4c4;
    flex-shrink: 0;

    @media (min-width: 800px) {
        border: 4px solid #b1144e;
    }

    &.success {
        border: 2px solid #6fbf8f;

        @media (min-width: 800px) {
            border: 4px solid #6fbf8f;
        }
    }
}

.person-card-headline {
    display: flex;
    flex-direction: column;
    flex: 1;

    h1 {
        font-size: 23px !important;
        line-height: 28px !important;

        @media (min-width: 800px) {
            font-size: 34px !important;
            line-height: 44px !important;
        }
    }

    h2 {
        font-size: 18px;
    }
}

.person-card-footer {
    display: flex;
    align-items: center;
    justify-content: center;

    .button {
        @media (max-width: 800px) {
            width: 48% !important;
            margin-left: 0;
            margin-bottom: 1%;
        }
    }

    @media (min-width: 800px) {
        justify-content: flex-end;
    }
}

.person-card-footer-buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: 20px;

    @media (min-width: 800px) {
        flex-wrap: unset;
    }
}

.person-card-action {
    display: flex;
    flex-direction: column;
}

.loader {
    animation: spin 0.2s linear infinite;
}

@keyframes spin {
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

.board-title {
    width: 100%;
    margin-bottom: 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.board-info-button {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    right: -6px;
    top: -1px;

    i {
        transition: all 0.2s ease;
        color: #0033ff;
    }

    &:hover {
        i {
            transform: scale(1.1);
            transition: all 0.2s ease;
        }
    }
}

.board-tabs-holder {
    display: flex;
    margin-bottom: 10px;
    border-bottom: 1px solid #a1b1c8;
    overflow-x: auto;

    @media (min-width: 800px) {
        margin-bottom: 60px;
    }
}

.board-tabs {
    display: flex;
    list-style: none;
    padding: 0;
    flex-direction: row;
    width: 100%;

    @media (min-width: 800px) {
        width: unset;
        flex-direction: row;
        overflow: auto;
    }

    li {
        min-width: 190px;
        height: 43px;
        padding: 10px;
        cursor: pointer;
        font-family: "hansen-grotesque-bold", sans-serif;
        font-weight: 700;
        color: #000;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        text-transform: uppercase;
        letter-spacing: 1px;
        padding: 0 30px;
        color: #0033ff;
        position: relative;

        @media (min-width: 800px) {
            flex-direction: row;
            border-bottom: none;
        }

        &.current {
            color: #000;

            &:after {
                content: "";
                width: 100%;
                height: 3px;
                background-color: #a1b1c8;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }
    }
}

.grade-selected {
    color: #fadb8c;
}

.icon-rock {
    color: #617594;
}

.icon-blue {
    color: #0033ff;
}

.person-card-content {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    width: 100%;
    flex-direction: column;

    @media (min-width: 800px) {
        flex-direction: row;
    }
}

.person-card-content-left {
    width: 100%;

    @media (min-width: 800px) {
        width: 40%;
    }
}

.person-card-content-right {
    @media (min-width: 800px) {
        width: 50%;
    }
}

.statistics {
    width: calc(100% + 56px);
    margin-left: -28px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 30px;
    border-bottom: 1px solid #a1b1c8;
    justify-content: center;
    padding: 18px 30px;
    font-size: 13px;
    font-weight: 700;
    text-transform: uppercase;
    font-family: "hansen-grotesque-bold";
    letter-spacing: 1px;
    background-color: #fdfdfd;
    font-family: "hansen-grotesque-bold", sans-serif;
    min-height: 50px;

    .headline {
        margin-bottom: 10px;
    }

    @media (min-width: 1070px) {
        flex-direction: row;
        align-items: center;
        margin-bottom: 42px;
    }

    ul {
        display: flex;
        flex-direction: column;
        font-family: "helvetica-regular";
        font-size: 13px;
        text-transform: none;
        font-weight: 400;
        padding: 10px 0;

        @media (min-width: 1070px) {
            flex-direction: row;
            padding: 0;
        }

        li {
            margin-bottom: 10px;

            @media (min-width: 1070px) {
                margin: 0 18px 0 10px;
            }
        }
    }
}

.loading-spinner {
    width: 20px;
    height: 20px;
    border: 2px solid #617594;
    border-top: 2px solid #0033ff;
    border-radius: 50%;
    animation: spin 2s linear infinite;
}

.journal-holder {
}

.journal-note-item {
    border-bottom: 1px solid #e5e5e5;
    padding-bottom: 10px;
    margin-bottom: 10px;
    font-size: 15px;
    line-height: 22px;
}

.journal-date {
    font-size: 13px;
    color: #617594;
}

.modal-content {
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 200px;
}

.modal-item-header {
    display: flex;
    align-items: center;
    margin-bottom: 38px;
}

.modal-item {
    width: calc(100% - 28px);
    max-width: 732px;
    background-color: #fff;
    padding: 30px 30px 40px 30px;
    border: 1px solid #617594;
    position: relative;
    display: flex;
    flex-direction: column;
    box-shadow: 4px 4px 4px 0px #00000026;
    max-height: 90vh;
}

.modal-buttons {
    padding-top: 40px;
}

.person-card-headline {
    h1 {
        font-size: 34px;
        letter-spacing: -1px;
        font-family: "hansen-grotesque-bold", sans-serif;
        line-height: 48px;
    }

    h2 {
        font-size: 23px;
        color: #617594;
        letter-spacing: -1px;
        font-family: "hansen-grotesque-bold", sans-serif;
    }
}

.litepicker-date {
    width: 100%;
    max-width: 670px;
    height: 50px;
    border: 1px solid rgba(161, 177, 200, 0.5);
    background-color: rgb(247, 248, 249);
    border-radius: 6px;
    padding: 0 20px;
    font-size: 16px;
    font-weight: 300;
    font-family: "hansen-grotesque-regular";
    display: flex;
    align-items: center;
    margin-top: -16px;
}

#litepicker {
    height: 0;
    border: 0;
    overflow: hidden;
}

.litepicker {
    margin-top: 60px;
}

#debug-date {
    position: fixed;
    right: 0;
    bottom: 0;
    background-color: #000;
    color: #fff;
    padding: 16px 24px;
    z-index: 10000000;

    a {
        color: #fff;
        text-decoration: none;
        margin-top: 4px;
    }
}

.modal-content p {
    margin-bottom: 30px;
}

.tooltip {
    display: v-bind("tooltipDisplay");
    position: fixed;
    background-color: #a1b1c8;
    color: #000;
    top: v-bind("tooltipY");
    left: v-bind("tooltipX");
    z-index: 10000;
    pointer-events: none;
    padding: 24px 30px 30px 30px;
    flex-direction: column;
    font-size: 12px;
    text-align: center;
    border-radius: 10px;
    width: 258px;
    background-image: url("../../../assets/info-background.svg");
    background-size: 30%;
    background-repeat: no-repeat;
    background-position: center center;
    opacity: 1;

    &.placement_bottom:after {
        content: "";
        width: 24px;
        height: 24px;
        background-color: #a1b1c8;
        position: absolute;
        top: -8px;
        right: calc(50% - 10px);
        transform: rotate(45deg);
        transform: rotate(49deg) skew(20deg, 10deg);
    }

    &.placement_top:after {
        content: "";
        width: 24px;
        height: 24px;
        background-color: #a1b1c8;
        position: absolute;
        bottom: -8px;
        right: calc(50% - 10px);
        transform: rotate(45deg);
        transform: rotate(49deg) skew(20deg, 10deg);
    }

    h3 {
        font-size: 16px;
        line-height: 20px;
        font-weight: bold;
        z-index: 2;
        margin-bottom: 8px;
    }

    p {
        font-size: 13px;
        line-height: 16px;
        z-index: 2;
    }
}

.modal-card-header-right {
    margin-left: auto;
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    margin-top: 30px;

    @media (min-width: 800px) {
        top: -22px;
        width: unset;
    }
}

.board-item-icons {
    display: flex;
    align-items: center;
    font-weight: 400;
    font-size: 15px;
    color: #617594;

    span {
        margin-left: 10px;
    }
}
.number-of-leads {
    font-family: "hansen-grotesque-bold";
    display: flex;
    align-items: center;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;

    @media (min-width: 800px) {
        margin-left: auto;
    }

    span {
        cursor: pointer;
        color: #0033ff;
    }

    .number-of-leads-center {
        color: #000;
        margin: 0 4px;
    }

    .active {
        color: #617594;
        cursor: default;
    }
}

.person-success {
    z-index: 100000;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .person-success-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 16px;
        font-family: "hansen-grotesque-bold";

        i {
            margin-bottom: 20px;
            font-size: 180px !important;
            color: #6fbf8f;
        }
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.modal-info-texts .modal-card .modal-content p {
    margin-bottom: 30px !important;
}

.modal-info-texts .modal-card .modal-content ul {
    list-style-type: disc;
    list-style-position: inside;
    margin-top: -20px;
    margin-bottom: 30px;

    li {
        list-style-type: disc;
        list-style-position: inside;
        padding-bottom: 15px;

        &:last-child {
            padding-bottom: 0;
        }
    }
}

.modal-info-texts .modal-card .modal-content h1 + ul,
.modal-info-texts .modal-card .modal-content h3 + ul,
.modal-info-texts .modal-card .modal-content h2 + ul,
.modal-info-texts .modal-card .modal-content h1 + ol,
.modal-info-texts .modal-card .modal-content h3 + ol,
.modal-info-texts .modal-card .modal-content h2 + ol {
    margin-top: 0;
}

.modal-card.modal-card-search-box {
    width: 730px;
    margin-top: 20px;
    padding: 26px 30px !important;
}

.search-results {
    overflow-y: auto;
    overflow-x: hidden;
    height: 300px;
    font-size: 12px;
    color: #617594;

    > div {
        box-shadow: 0px 1px 0px 0px #00000040;
        padding: 12px 0;
        cursor: pointer;
    }
}

.outcome-arrow {
    font-size: 23px;
    margin: 0 6px;
    top: 1px;
    position: relative;
}

.log-arrow {
    font-size: 20px;
    margin: 0 6px;
    top: 5px;
    position: relative;
}
</style>
